import { createSlice } from '@reduxjs/toolkit';

export const videoSlice = createSlice({
  name: 'videoSlice',
  initialState: {
    isShowToast: false,
    isShowLoading: false,
    deviceSerial: null
  },
  reducers: {
    showToast: state => {
      state.isShowToast = true;
    },
    closeToast: state => {
      state.isShowToast = false;
    },
    showLoading: (state, action) => {
      state.isShowLoading = true;
      let serialPre = state.deviceSerial;
      let checkType = action.payload.type;

      if(serialPre !== action.payload.device_serial || (checkType === 'keepSerial' && serialPre === action.payload.device_serial)){
        state.deviceSerial = action.payload.device_serial;
      } else {
        state.deviceSerial = null;
      }
    },
    closeLoading: state => {
      state.isShowLoading = false;
    },

    resetVideoSlice: state => {
      state.isShowToast = false;
      state.isShowLoading = false;
      state.deviceSerial = null;
    }
  }
});
export const {
  showToast,
  closeToast,
  showLoading,
  closeLoading,
  resetVideoSlice
} = videoSlice.actions;

export default videoSlice.reducer;
